import { isPositiveNumber } from "et3-type-guards";
import React from "react";
import {
  ADMIN_SUPERVISE_PICKER_ENTRIES,
  EVENTS_LIMIT
} from "../../../../constants/picker-entries-constants";
import i18n from "../../../../constants/i18n";
import getRootStore from "../../../../stores/core/root-store";
import { getSupervisedEventsStore } from "../../../../stores/supervisor-store/supervised-events-store";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Date from "../../../../core/et3-input/et3-date";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import { ISSUES_ARRAY } from "../../../../constants/input-entries-constants";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";
import { reducerToZeroIfUndefined } from "../../../../helpers/et3-picker-data-helper";

const SupervisedEventsForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const allAdmins = getRootStore().allAdmins.get();
  const isEnabled = isPositiveNumber(
    reducerToZeroIfUndefined(
      parseInt(getSupervisedEventsStore().adminInput.get().value, 10)
    )
  );

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("ADMIN")}
          options={allAdmins}
          value={getSupervisedEventsStore().adminInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getSupervisedEventsStore().setAdmin(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("TYPE")}
          options={ADMIN_SUPERVISE_PICKER_ENTRIES}
          value={getSupervisedEventsStore().typeInputSupervisedEvent.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getSupervisedEventsStore().setTypeInputSupervisedEvent(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("ISSUE_TYPE")}
          options={ISSUES_ARRAY}
          value={getSupervisedEventsStore().typeInputSupervisedIssue.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getSupervisedEventsStore().setTypeInputSupervisedIssue(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("LIMIT")}
          options={EVENTS_LIMIT}
          value={getSupervisedEventsStore().limitInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getSupervisedEventsStore().setLimitInput(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MIN")}
          dateInputObservable={getSupervisedEventsStore().dateMinInput}
          isEnabled={true}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MAX")}
          dateInputObservable={getSupervisedEventsStore().dateMaxInput}
          isEnabled={true}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        text="GET"
        type="GET"
        onClick={async () => {
          await getSupervisedEventsStore().getSupervisedEvents();
        }}
        isEnabled={isEnabled}
        size="LARGE"
      />
    </React.Fragment>
  );
});
export default SupervisedEventsForm;
